module.exports = __webpack_public_path__ + "static/grafia-38db2bd11aede002c035ccf66dc9f652.svg";